import { User } from './../../models/user';
import { PosUserAndSellerListModalComponent } from '../../shared/pos-user-and-seller-list-modal/pos-user-and-seller-list-modal.component';
import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CustomerTableModel } from 'src/app/models/table-models/customer-table';
import { PosUpdateRtnFiscalIdModalComponent } from 'src/app/shared/pos-update-rtn-fiscal-id-modal/pos-update-rtn-fiscal-id-modal.component';
import { ModalDialogType, UserAndSellerShowMode } from '../constants';
import { first } from 'rxjs/operators';


@Injectable({
  providedIn: 'root',
})
export class PosUserAndSellerListModalService{
  private modalRef?: BsModalRef<PosUserAndSellerListModalComponent>;
  constructor(private modalService: BsModalService) {

  }

  async show(
    mode: UserAndSellerShowMode,
    needsLogin: boolean
  ): Promise<CustomerTableModel | User | undefined> {
    this.modalRef = this.modalService.show(PosUserAndSellerListModalComponent, {
      initialState: {
        mode,
        needsLogin,
      },
    });

    this.modalRef.setClass(`modal-dialog ${ModalDialogType.PRIMARY}`);

    const selectedValue =
      await this.modalRef.content!.selectedValueChange.toPromise();

    return selectedValue;
  }
}
